// 通用的列表分页查询
import apis from "@/config/apis";
export default {
  data: () => ({
    defaultParams: {
      size: 10,
      page: 0,
      column: "",
      sort: ""
    },
    baseList: [],
    sortlist: [],
    baseColumn: [],
    total: 0,
    modal: {},

    loading: false,
    finished: false
  }),
  methods: {
    fetch(params, reload) {
      // reload用来判断是增加查询还是重新查询
      // 主要用于处理切换column和sort
      if (reload) {
        this.reload();
      } else {
        this.defaultParams.page = ++this.defaultParams.page;
      }
      // 直播预告、直播回放、项目等与通用的列表查询接口不一致
      if (params.category === "zhibhg") {
        this.fetchGetReviewList(params);
      } else if (params.category === "zhibyg") {
        this.fetchGetLiveList(params);
      } else if (params.category === "jingpxs") {
        this.fetchGetProjectList(params);
      } else if (params.category === "wmhlist") {
        this.fetchGetWmhList(params);
      } else {
        this.fetchGetList(params);
      }
    },
    // 正式的请求方法，这里后台接口、参数、返回值都不一样
    // 真的坑啊
    // 有时间想办法封装下
    async fetchGetList(params) {
      const resp = await apis.list.getList({
        ...this.defaultParams,
        ...params
      });
      if (resp.success === "ok") {
        // 接口返回的数据缺少默认状态，需要手动添加
        resp.columnlist.unshift({ code: "", name: "全部" });
        resp.sortlist.unshift({ code: "", name: "综合排序" });
        this.baseList = this.baseList.concat(resp.courselist);
        // 过滤下属性名
        this.baseColumn = resp.columnlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.sortlist = resp.sortlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.total = resp.total;
        this.modal = resp;

        this.loaded();
      }
    },
    // 直播列表
    async fetchGetLiveList(params) {
      const resp = await apis.list.getLiveList({
        ...this.defaultParams,
        ...params,
        status: params.column
      });

      if (resp.success === "ok") {
        // 接口返回的数据缺少默认状态，需要手动添加
        resp.statuslist.unshift({ code: "", name: "全部" });
        resp.sortlist.unshift({ code: "", name: "综合排序" });
        this.baseList = this.baseList.concat(resp.zblist);
        // 过滤下属性名
        this.baseColumn = resp.statuslist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.sortlist = resp.sortlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.total = resp.total;
        this.modal = resp;

        this.loaded();
      }
    },
    async fetchGetReviewList(params) {
      const resp = await apis.list.getReviewList({
        ...this.defaultParams,
        ...params,
        academic: params.column
      });
      if (resp.success === "ok") {
        resp.academiclist.unshift({ code: "", name: "全部" });
        resp.sortlist.unshift({ code: "", name: "综合排序" });

        this.baseList = this.baseList.concat(resp.zblist);
        this.baseColumn = resp.academiclist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.sortlist = resp.sortlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.total = resp.total;
        this.modal = resp;

        this.loaded();
      }
    },
    async fetchGetProjectList(params) {
      const resp = await apis.list.getProjectList({
        ...this.defaultParams,
        ...params,
        series: params.column
      });
      if (resp.success === "ok") {
        resp.serieslist.unshift({ code: "", name: "全部" });
        resp.sortlist.unshift({ code: "", name: "综合排序" });

        this.baseList = this.baseList.concat(resp.courselist);
        this.baseColumn = resp.serieslist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.sortlist = resp.sortlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.total = resp.total;
        this.modal = resp;

        this.loaded();
      }
    },
    async fetchGetWmhList(params) {
      const resp = await apis.list.getWmhList({
        ...this.defaultParams,
        ...params
      });
      if (resp.success === "ok") {
        resp.columnlist.unshift({ code: "", name: "全部" });
        resp.sortlist.unshift({ code: "", name: "综合排序" });

        this.baseList = this.baseList.concat(resp.portallist);
        this.baseColumn = resp.columnlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.sortlist = resp.sortlist.map(item => {
          return { text: item.name, value: item.code };
        });
        this.total = resp.total;
        this.modal = resp;

        this.loaded();
      }
    },
    // 一次分页加载结束
    loaded() {
      this.loading = false;
      if (this.baseList.length >= this.total) {
        this.finished = true;
      }
    },
    // 重置分页列表参数状态
    reload() {
      this.defaultParams.page = 1;
      this.baseList = [];
      this.finished = false;
    }
  }
};
